import React, { useContext } from "react";
import PropTypes from "prop-types";
import { TARIFF_INFORMATION } from "../../content/index.content";
import { MediaAuthContext } from "../../../../../store/context/media-auth-context";
import { SimpleContext } from "../../../../../store/context/simple-context";
import { getTrueClasses } from "../../../../../helpers";
import Question from "../../Question";
import "./index.scss";

const Navigation = ({ period, navRef }) => {
  const {
    media: { isNotInitMobile },
  } = useContext(MediaAuthContext);
  const {
    data: { currentPeriod, availableTariffs, tableState },
    translate: { t },
    update: { navigationHandler, tableOpenHandler },
  } = useContext(SimpleContext);
  const active = currentPeriod === period;
  const {
    title,
    subTitle,
    offer: { icon, name, price, cents },
  } = TARIFF_INFORMATION[availableTariffs[period]];
  const tablePeriod = isNotInitMobile ? period : "common";
  return (
    <div
      key={period}
      className={getTrueClasses(
        "GP-C-To-N",
        `GP-C-To-N_${period}`,
        active && "GP-C-To-N_active"
      )}
      ref={navRef}
    >
      {icon && <p className="GP-C-To-N__icon">{t(icon)}</p>}
      <div className="GP-C-To-N-blockTitle">
        <p className="GP-C-To-N__name">{t(name)}</p>
        <p className="GP-C-To-N__title">{t(title)}</p>
        <p className="GP-C-To-N__text">{t("(PRO AI Extension included)")}</p>
        {subTitle && (
          <p className="GP-C-To-N__subTitle">
            {t(subTitle.text)}
            <Question tooltip={t(subTitle.tooltip)} leftView />
          </p>
        )}
      </div>
      <div className="GP-C-To-N-blockPayment">
        <p className="GP-C-To-N__payment">
          {`$${price.toLocaleString(t("language code"), { useGrouping: true })}`}
          {cents && <sup className="GP-C-To-N__cents">{cents}</sup>}
        </p>
        <div
          className="GP-C-To-N__btn"
          onClick={() => navigationHandler(period)}
        >
          {t(active ? "Selected" : "Select")}
        </div>
        <p className="GP-C-To-N__agree">{t("10-day money-back guarantee")}</p>
        <p
          className={getTrueClasses(
            "GP-C-To-N__seeAll",
            tableState[tablePeriod].open && "GP-C-To-N__seeAll_hide"
          )}
          onClick={() => tableOpenHandler(tablePeriod, true)}
        >
          {t("See all features")}
        </p>
      </div>
    </div>
  );
};
Navigation.propTypes = {
  period: PropTypes.string,
};
export default Navigation;
